import React, { useState } from "react";
import { SiteDetailsResponseModel } from "@models/site";
import UnbxdLogoText from "@assets/images/svg/unbxd_logo_text.svg";
import UnbxdLogoLightText from "@assets/images/svg/unbxd_light_2.svg";
import MenuBar from "./MenuBar";
import Button from "@components/common/Button";
import { FiMenu } from "react-icons/fi";
import { navThemeBasedClass } from "@utils/constant";
import { twMerge } from "tailwind-merge";
import { Link } from "gatsby";

export interface NavBarPropsModel {
  navigation: SiteDetailsResponseModel["navigation"];
  darkTheme: boolean;
}
const ResponsiveNav: React.FunctionComponent<NavBarPropsModel> = ({
  navigation,
  darkTheme,
}) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const navTheme = darkTheme ? "dark" : "light";
  const navClass = navThemeBasedClass?.[navTheme];

  const renderLogo = () => (
    <div className="overflow-hidden h-8 w-[160px]">
      <Link to="/">
        {darkTheme ? <UnbxdLogoText /> : <UnbxdLogoLightText />}
      </Link>
    </div>
  );

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div
      className={twMerge(
        "flex justify-between items-center relative px-8 h-[70px]",
        navClass
      )}
    >
      {renderLogo()}
      <Button variant="transparent" className="" onClick={toggleMenu}>
        <FiMenu size={32} />
      </Button>
      <MenuBar
        navigation={navigation}
        isOpen={showMenu}
        setShowMenu={setShowMenu}
      />
    </div>
  );
};

export default ResponsiveNav;
